import { Icon, Icons, Size, TextIconColor } from '..';
import { cn } from '../../../utils/tailwind.utils';

import { CalloutType } from './Callout.consts';

// Map each callout type to its corresponding Tailwind color
const CALLOUT_COLOR_MAP: Record<CalloutType, string> = {
  [CalloutType.SECURITY]: 'primary-active',
  [CalloutType.ERROR]: 'fuchsia-error',
  [CalloutType.INFO]: 'gray',
  [CalloutType.WARNING]: 'yellow-warning'
};

interface CalloutProps {
  children: React.ReactNode;
  type: CalloutType;
  endElement?: React.ReactNode;
}

const getCalloutIcon = (type: CalloutType) => {
  switch (type) {
    case CalloutType.ERROR:
      return Icon.ERROR;
    case CalloutType.INFO:
      return Icon.INFO;
    case CalloutType.WARNING:
      return Icon.WARNING;
    case CalloutType.SECURITY:
      return Icon.LOCK;
    default:
      return Icon.INFO;
  }
};

const Callout: React.FC<CalloutProps> = ({ type, children, endElement }) => {
  const borderAndBackgroundColor = CALLOUT_COLOR_MAP[type];

  return (
    <div
      className={cn(
        'border-1 box-border flex flex-row items-stretch rounded-lg',
        `border-${borderAndBackgroundColor}`
      )}
      data-testid="callout-container"
    >
      <div
        className={cn(
          'flex items-center justify-center rounded-l px-[14px]',
          `bg-${borderAndBackgroundColor}`
        )}
        data-testid="callout-icon-container"
      >
        <Icons
          color={
            type === CalloutType.WARNING
              ? TextIconColor.BLACK
              : TextIconColor.PRIMARY
          }
          icon={getCalloutIcon(type)}
          size={Size.LARGE}
        />
      </div>
      <div
        className="flex w-full flex-row items-center justify-between pr-2"
        data-testid="callout-content-container"
      >
        <div
          className="flex-1 px-2.5 py-3 [&>span]:text-white"
          data-testid="callout-content"
        >
          {children}
        </div>
        {endElement}
      </div>
    </div>
  );
};

export default Callout;
